import styled from 'styled-components';

// Components
import { DateTime } from '../../../inputs/DateTime';
import InputText from '../../../inputs/InputText';
import {
  InputContainer,
  InputValue,
  Label,
  Container as ContainerInputText,
} from '../../../inputs/InputText/styles';
import { InputTextArea } from '../../../inputs/InputTextArea';
import { Area, Container } from '../../../inputs/InputTextArea/styles';
import { Typography } from '../../Typography';

// Types
import { RightArrowProps } from './types';
import DropDownInput from '../../../inputs/DropDown/DropDownInput';
import { ButtonIconBackground } from '../../../inputs/buttons/ButtonIconBackground';

export const ContainerOT = styled.div`
  max-width: 95%;
  width: 100%;
  background-color: ${({ theme }) => theme.colors.verySoftRed};
  border-radius: 8px;
  padding: 4rem;
  @media (max-width: ${({ theme }) =>
      theme.breakPoints.landscapeTablet * theme.percentBaseResponsive}rem) {
    max-width: 92%;
  }
  @media (max-width: ${({ theme }) =>
      theme.breakPoints.portraitTablet * theme.percentBaseResponsive}rem) {
    max-width: 100%;
  }
`;

export const ContainerHeader = styled.div`
  width: 100%;
  display: flex;
  justify-content: space-between;
  align-items: center;
  cursor: pointer;
`;

export const TitleOrder = styled.h2`
  font-size: ${({ theme }) => theme.fontSize.L};
  font-weight: ${({ theme }) => theme.fontWeight.semiBold};
`;

export const ContainerRefIcon = styled.div`
  display: flex;
  align-items: center;
  gap: 1.5rem;
`;

export const RefRoid = styled(Typography)`
  font-size: ${({ theme }) => theme.fontSize.S};
`;

export const RightArrow = styled.img<RightArrowProps>`
  transform: ${({ showInfo }) => (showInfo ? `rotate(90deg)` : null)};
  width: 1.4rem;
  height: 1rem;
`;

export const ContainerContent = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  position: relative;
  gap: 3.2rem;

  @media (max-width: ${({ theme }) =>
      theme.breakPoints.portraitTablet * theme.percentBaseResponsive}rem) {
    gap: 2.6rem;
  }
`;

export const ContainerData = styled.div`
  display: flex;
  margin-top: 3.2rem;
  gap: 3.2rem;
  flex-wrap: wrap;
  @media (max-width: ${({ theme }) =>
      theme.breakPoints.portraitTablet * theme.percentBaseResponsive}rem) {
    gap: 2.6rem;
    margin-top: 2.6rem;
  }
`;

export const LocationGroup = styled.div`
  display: flex;
  gap: 3.2rem 1rem;
  flex-wrap: wrap;
  width: 100%;

  @media (max-width: ${({ theme }) =>
      theme.breakPoints.portraitTablet * theme.percentBaseResponsive}rem) {
    gap: 1rem;
  }
`;

export const ConcessionWrapper = styled.div`
  display: flex;

  @media (max-width: ${({ theme }) =>
      theme.breakPoints.portraitTablet * theme.percentBaseResponsive}rem) {
    flex: 0 0 auto;
    max-width: 10rem;
    min-width: 7rem;
  }
`;

export const RoadSubGroup = styled.div`
  display: flex;
  gap: 1rem;
  flex-wrap: wrap;
  flex: 1;
  min-width: 0;

  @media (max-width: ${({ theme }) =>
      theme.breakPoints.portraitTablet * theme.percentBaseResponsive}rem) {
    gap: 1rem;
  }
`;

export const PkGroup = styled.div`
  display: flex;
  gap: 1rem;
  flex-wrap: wrap;

  @media (max-width: ${({ theme }) =>
      theme.breakPoints.portraitTablet * theme.percentBaseResponsive}rem) {
    gap: 1rem;
  }
`;

export const DateInput = styled(DateTime)`
  label {
    width: 18.1rem;
  }
  input {
    border: ${(prop) => (prop.isDisabled ? `none` : null)};
  }
`;

export const DropDownCapitol = styled(DropDownInput)``;

export const DropDownSubcapitol = styled(DropDownInput)``;

export const DropDownConcession = styled(DropDownInput)``;

export const InputPKInit = styled(InputText)`
  &${ContainerInputText} {
    max-width: 16rem;
  }
  ${InputContainer} {
    max-width: 16rem;
    min-width: 7.5rem;
    padding: 0.7rem 1.4rem;
  }
  &${Label} {
    font-size: ${({ theme }) => theme.fontSize.S};
  }

  @media (max-width: ${({ theme }) =>
      theme.breakPoints.landscapeTablet * theme.percentBaseResponsive}rem) {
    ${InputValue} {
      max-width: 7.1rem;
      font-size: ${({ theme }) => theme.fontSize.XS};
    }
    &${Label} {
      font-size: ${({ theme }) => theme.fontSize.XS};
    }
  }

  @media (max-width: ${({ theme }) =>
      theme.breakPoints.portraitTablet * theme.percentBaseResponsive}rem) {
    ${InputValue} {
      max-width: 20rem;
    }
    &${ContainerInputText} {
      max-width: 20rem;
    }
    ${InputContainer} {
      max-width: 20rem;
    }
  }
`;

export const InputPKEnd = styled(InputText)`
  &${ContainerInputText} {
    max-width: 16rem;
  }
  ${InputContainer} {
    max-width: 16rem;
    min-width: 7.5rem;
    padding: 0.7rem 1.4rem;
  }
  &${Label} {
    font-size: ${({ theme }) => theme.fontSize.S};
  }

  @media (max-width: ${({ theme }) =>
      theme.breakPoints.landscapeTablet * theme.percentBaseResponsive}rem) {
    ${InputValue} {
      width: 7.1rem;
      font-size: ${({ theme }) => theme.fontSize.XS};
    }
    &${Label} {
      font-size: ${({ theme }) => theme.fontSize.XS};
    }
  }

  @media (max-width: ${({ theme }) =>
      theme.breakPoints.portraitTablet * theme.percentBaseResponsive}rem) {
    ${InputValue} {
      max-width: 20rem;
    }
    &${ContainerInputText} {
      max-width: 20rem;
    }
    ${InputContainer} {
      max-width: 20rem;
    }
  }
`;

export const ContainerDescription = styled.div`
  display: flex;
  align-items: flex-end;
  width: 100%;
  gap: 2.9rem;
`;

export const InputDescription = styled(InputTextArea)`
  &${Container} {
    width: 100%;
    min-height: 21rem;
  }
  ${Area} {
    background-color: ${(props) =>
      props.disabled
        ? `${props.theme.colors.greyLight}`
        : `${props.theme.colors.white}`};
    border: ${({ disabled }) => (disabled ? `none` : null)};
    color: ${(props) =>
      props.disabled
        ? `${props.theme.colors.greyVeryDark}`
        : `${props.theme.colors.black}`};
    width: 100%;
    min-height: 21rem;
    font-size: ${({ theme }) => theme.fontSize.S};

    @media (max-width: ${({ theme }) =>
        theme.breakPoints.landscapeTablet * theme.percentBaseResponsive}rem) {
      min-height: 21rem;
      font-size: ${({ theme }) => theme.fontSize.XS};
    }
    @media (max-width: ${({ theme }) =>
        theme.breakPoints.portraitTablet * theme.percentBaseResponsive}rem) {
      height: 21rem;
      min-height: 21rem;
      font-size: ${({ theme }) => theme.fontSize.XS};
    }
  }
`;

export const ButtonSave = styled(ButtonIconBackground)``;
export const ButtonEdit = styled(ButtonIconBackground)``;
